import update_stage from './_stage-manager';

export default function init_reveal(event) {

	//fetch the essential styles
	let styles = document.getElementById('basic-styles');
	let loader = document.getElementById('loader');

	//if we have styles and the loader
	if(styles && loader) {

		//remove them
		styles.remove();
		loader.remove();
	}

	setTimeout(function() {
		let vortex = document.getElementsByTagName('canvas')[0];

		if(vortex) {

			vortex.classList.add('vortex-complete');
			document.body.classList.add('allow-stage-manager');

			
			setTimeout(function() {
				//fetch our menu toggle
				let menu = document.getElementById('menu');

				//if we've found it
				if(menu) {
					setTimeout(function() {
						//add the class allowing it to be interactive
						menu.classList.add('active');
					}, 1000)
				}

				update_stage(1);
			}, 1000);
		}
	}, 5000)

}